import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { EnumTipoParamAnexo } from '../../../oData/enums/enumTipoParamAnexo'
import { AnnexedContractModelPostRequest } from '../contracts/model/contracts'
import { AnnexedParamsModel } from './model/annexedParams'

export const apiGetAnnexedContracts = async (
  commodity?: number,
  country?: number
): Promise<AnnexedParamsModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    // `https://localhost:59923/api/AnnexedParams/FetchAnnexedParamsTypeContract?commodityID=${commodity}&countryID=${country}`
    `${apiSuffixUrl}/api/AnnexedParams/FetchAnnexedParamsTypeContract?commodityID=${commodity}&countryID=${country}`
  ).then(response => {
    if (response.data != undefined) {
      return response.data
    }
  })
}

export const apiGetAnnexedParamsByType = async (
  paramType: EnumTipoParamAnexo,
  commodity?: number,
  country?: number
): Promise<AnnexedParamsModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    // `https://localhost:59923/api/AnnexedParams/FetchAnnexedParamsByType?paramType=${paramType}&commodityID=${commodity}&countryID=${country ?? 1}`
    `${apiSuffixUrl}/api/AnnexedParams/FetchAnnexedParamsByType?paramType=${paramType}&commodityID=${commodity}&countryID=${country ?? 1}`
  ).then(response => {
    if (response.data != undefined) {
      return response.data
    }
  })
}
